import React from 'react';
import { Select, Button, FormField, Badge } from 'AWS-UI-Components-React';

export class MappingEntry extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showType: props.showType,
      operation: props.operation,
      type: props.type,
      value: props.value,
      index: props.index || 0,
      editCallback: props.editCallback,
      removeCallback: props.removeCallback,
      types: props.types,
      cpValueTypes: props.cpValueTypes,
      columnsMap: props.columnsMap,
      subComponentDropdownValues: props.subComponentDropdownValues,
    };

    this.state.columnCount = props.showType ? 4 : 3;
    this.state.columns = this.state.columnsMap[this.state.type].filter(c => this.isInDropDownValues(this.state.subComponentDropdownValues, c));

    if (this.state.index === 0) {
      this.state.signLabel = 'Sign';
      this.state.datasetLabel = 'Dataset';
      this.state.valueLabel = 'Value';
      this.state.actionLabel = ' ';
    } else {
      this.state.signLabel = '';
      this.state.datasetLabel = '';
      this.state.valueLabel = '';
      this.state.actionLabel = '';
    }

    this.onValueEdit = this.onValueEdit.bind(this);
  }

  signOptions = [
    {
      label: '+',
      id: '+',
    },
    {
      label: '-',
      id: '-',
    },
  ];

  isInDropDownValues = (dropdownValues, column) => {
    if (!dropdownValues.length) {
      return true;
    }
    return dropdownValues.map(v => v.value).includes(column.id)
  };

  onDatasetChange = (event) => {
    let id = event.detail.selectedId;
    let columns = id === 'Cognos' ? this.state.columnsMap[id].filter(c => this.isInDropDownValues(this.state.subComponentDropdownValues, c))
                                                       : this.state.columnsMap[id];
    this.setState({
      columns: columns,
      type: event.detail.selectedId,
    });
    let mapping = {
      index: this.state.index,
      type: event.detail.selectedId,
      operation: this.state.operation,
      value: this.state.value,
    };
    this.state.editCallback(this.state.value, mapping);
  };

  onSignEdit = (event) => {
    this.setState({ signLabel: event.detail.selectedId });
    let mapping = {
      index: this.state.index,
      operation: event.detail.selectedId,
      type: this.state.type,
      value: this.state.value,
    };
    this.state.editCallback(this.state.value, mapping);
  };

  onValueEdit = (event) => {
    this.setState({ valueLabel: event.detail.selectedId });
    let mapping = {
      index: this.state.index,
      operation: this.state.operation,
      type: this.state.type,
      value: event.detail.selectedId,
    };
    this.state.editCallback(this.state.value, mapping);
  };

  onRemove = () => {
    this.state.removeCallback(this.state.value);
  };

  render() {
    {this.state.type.includes('Cognos') && this.state.columns.filter(c => this.isInDropDownValues(this.state.subComponentDropdownValues, c))}
    {this.state.types = this.state.type.includes('ACCRUED_CP') ? this.state.cpValueTypes : this.state.type.includes('O_WBR_FIXED_COST') ? this.state.cpValueTypes : this.state.type.includes('FCFIXED_COST_ASIN_BY_FC_ACCRUED') ? this.state.cpValueTypes : this.state.types}
    let { columns } = this.state;
    let ignoredItem = false;

    let selectedOption = columns && columns.find((item) => item.id === this.state.value);
    if (!selectedOption && this.state.value) {
      selectedOption = { id: this.state.value, label: this.state.value, value: this.state.value };
      columns = [...columns, selectedOption];
      ignoredItem = true;
    }

    return (
      <tr>
        <td>
          <FormField label={this.state.signLabel}>
            <Select options={this.signOptions} selectedId={this.state.operation} onChange={this.onSignEdit} />
          </FormField>
        </td>
        <td style={{width: '20%'}}>
          {this.state.showType && (
            <FormField label={this.state.datasetLabel} description="">
              <Select
                options={this.state.types}
                disabled={!this.state.showType}
                onChange={this.onDatasetChange}
                selectedId={this.state.type}
              />
            </FormField>
          )}
        </td>
        <td style={{width: '40%'}}>
          <FormField label={this.state.valueLabel}>
            <Select
              options={columns}
              enableFiltering={true}
              filteringType={'auto'}
              onChange={this.onValueEdit}
              selectedOption={selectedOption}
            />
          </FormField>
        </td>
        <td style={{width: '100%'}}>
          <FormField label={this.state.actionLabel}>
            <Button text={'Remove'} onClick={this.onRemove} />
            {' '}
            {ignoredItem && <Badge color="red" content="Ignored" />}
          </FormField>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/mapper/mapping_entry.jsx